
import NotFound from '../views/404.vue'
import Home from '../views/Home.vue'
import Contract_users from '../views/tableList/ContractUsers.vue'
import Contracts from '../views/tableList/Contracts.vue'
import Companies from '../views/tableList/Companies.vue'
import RepaymentUse from '../views/tableList/RepaymentUse.vue'
import ResetPassword from '../views/personalCenter/ResetPassword.vue'
import RepaymentChange from '../views/tableList/RepaymentChange.vue'
import BusInstallment from '../views/tableList/BusInstallment.vue'
import BusInterestTransferLog from '../views/tableList/BusInterestTransferLog.vue'
import BusTradingResult from '../views/tableList/BusTradingResult.vue'
const routes = [
  {
    path: '/',
    component: Home,
    name: '主页',
    iconCls: 'el-icon-location-outline',//图标样式class
    leaf: true,
    authority: ['admin','guest']
  },
  {
    path: '/404',
    component: NotFound,
    name: '',
    hidden: true
  },
 
  {
    path: '/contracts',
    component: Home,
    name: '合同管理',
    iconCls: 'el-icon-document',
    children: [
      { path: 'lists', component: Contracts, name: '合同列表' },
      { path: 'users', component: Contract_users, name: '合同用户列表' },
    ]
  },
  {
    path: '/bus_installments',
    component: Home,
    name: 'Bus工单管理',
    iconCls: 'el-icon-upload',//图标样式class
    children: [
      { path: 'lists', component: BusInstallment, name: '工单列表' },
      { path: 'bus_offline_pay_logs', component: RepaymentUse, name: '线下还款上报记录' },
      { path: 'bus_bill_change_logs', component: RepaymentChange, name: '账单变化记录' },
      { path: 'bus_interest_transfer_logs', component: BusInterestTransferLog, name: '工单贴息记录' },
      { path: 'bus_trading_result', component: BusTradingResult, name: '交易回调' },
    ]
  },
  {
    path: '/companies',
    component: Home,
    name: '公司管理',
    iconCls: 'el-icon-tickets',
    children: [
      { path: 'lists', component: Companies, name: '公司列表' },
    ]
  },
  {
    path: '/',
    component: Home,
    name: '账号设置',
    hidden: true,
    children: [
      { path: '/reset_password', component: ResetPassword, name: '修改密码', hidden: true },
    ]
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js